/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

var config = {
  name: 'useTags',
  // REQUIRED Name of the data hook, should be the same as the file name.
  type: 'retrieve',
  // REQUIRED Data Hook type, currently retrieve or modify
  uri: '/account/api/tagging/v3/tags',
  // REQUIRED URL that will be called with this request
  method: 'GET',
  // REQUIRED REST method used for the API call
  documentation: {
    // Highly recommended, these are used for loading the documentation in the mdx file
    model: {
      tags: [{
        name: {
          type: 'String',
          description: 'Name of the tag'
        },
        providers: [{
          type: 'String',
          description: 'Where the tags come from, IMS or Ghost'
        }],
        attached_to_resources: {
          ghost: {
            type: 'Int',
            description: 'Number of ghost items this tag is attached to'
          },
          ims: {
            type: 'Int',
            description: 'Number of IMS items this tag is attached to'
          }
        }
      }],
      success: {
        type: 'Boolean',
        description: 'Flag that indicates whether the request was successful or not'
      }
    },
    params: 'This API takes no params'
  },
  // Modify Data Hooks Return a function
  mock: {
    isLoading: false,
    tags: [{
      name: 'env:tag-1',
      providers: ['ghost', 'ims'],
      attached_to_resources: {
        ghost: 2,
        ims: 1
      }
    }, {
      name: 'abc:tag-2',
      providers: ['ghost', 'ims'],
      attached_to_resources: {
        ghost: 2,
        ims: 1
      }
    }, {
      name: 'proj:tag-3',
      providers: ['ghost', 'ims'],
      attached_to_resources: {
        ghost: 2,
        ims: 1
      }
    }, {
      name: 'dev:tag-1',
      providers: ['ghost', 'ims'],
      attached_to_resources: {
        ghost: 2,
        ims: 1
      }
    }, {
      name: 'dev:tag-2',
      providers: ['ghost', 'ims'],
      attached_to_resources: {
        ghost: 2,
        ims: 1
      }
    }, {
      name: 'testing:testingforaverylongname12345',
      providers: ['ghost', 'ims'],
      attached_to_resources: {
        ghost: 2,
        ims: 1
      }
    }],
    success: true
  }
};
var useTagsConfig = config;

export { useTagsConfig as default };
